<template>
  <!-- 对话框 -->
  <el-drawer :visible.sync="show" :with-header="false" :before-close="closeDialog" size="80%">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">

          <el-form-item label="活动名称:" label-width='120px'>
            <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="活动图片:" label-width='120px'>


            <el-image :preview-src-list="srcList" v-if="img_url.cover_img_imageUrl" :src="img_url.cover_img_imageUrl"
                      class="avatar"></el-image>
            <el-upload :class="img_url.cover_img_imageUrl?'border-none':''" class="avatar-uploader"
                       :action="img_upload_url" :show-file-list="false" :on-success="coverImgSuccess"
                       :before-upload="beforeAvatarUpload" :headers="img_headers">
              <el-button slot="trigger" v-if="img_url.cover_img_imageUrl" @click="img_url.cover_img_imageUrl=''"
                         style="width: 100px; margin-top: 10px;">更换图片</el-button>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>


          </el-form-item>


          <el-form-item label-width='100px'>


            <p class="text-red">*注：活动图片尺寸应为650*712</p>


          </el-form-item>


          <el-form-item label="链接跳转模式:" label-width='120px'>
            <el-select v-model="submit_data.type" placeholder="请选择" @change="typeChange">
              <el-option
                      label="跳转网页"
                      value="0">
              </el-option>
              <el-option
                      label="小程序"
                      value="1">
              </el-option>
              <el-option
                      label="内部链接"
                      value="3">
              </el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="内部链接地址:" v-if="submit_data.type=='3'" label-width='120px'>
            <el-select v-model="submit_data.inside_link" placeholder="请选择">
              <el-option
                      v-for="item in insideLinkList"
                      :label="item.name"
                      :value="item.key">
              </el-option>

            </el-select>
          </el-form-item>


          <el-form-item label="小程序原始id:" label-width='120px' v-if="submit_data.type == '1'">
            <el-input v-model="submit_data.origin_appid" style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="小程序appid:" label-width='120px' v-if="submit_data.type == '1'">
            <el-input v-model="submit_data.appid" style="width: 80%;">
            </el-input>
          </el-form-item>


          <el-form-item label="链接地址:" label-width='120px'>
            <el-input v-model="submit_data.link" style="width: 80%;">
            </el-input>
          </el-form-item>








          <el-form-item label="备注:" label-width='120px'>
            <el-input v-model="submit_data.remarks" style="width: 80%;">
            </el-input>
          </el-form-item>


        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center;margin-top: 20px;">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>

    </div>




  </el-drawer>
</template>

<script>
  var _this;
  import {
    config
  } from '@/utils/config'; // 配置
  import axios from 'axios'; // AJAX封装类

  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import {
    quillEditor
  } from 'vue-quill-editor';
  export default {
    components: {
      quillEditor
    },
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        // 获取上传图片的地址
        this.img_upload_url = config.axios_imgURL;



        // 清空图片的路径
        this.img_url = {
          cover_img_imageUrl:''
        };


        axios.defaults.baseURL = config.axios_normalURL; //请求base url
        _this.$post(
                '/system/getInsideLink'
        ).then(res => {
          _this.insideLinkList= res.data

          axios.defaults.baseURL = config.axios_baseURL; //请求base url

        }).catch((err) => {

        });
        axios.defaults.baseURL = config.axios_baseURL; //请求base url


        // 获取广告详情
        _this.$post(
            "/advert/getActiveDetails", {
              active_code: _this.data
            }
          )
          .then(res => {

            _this.submit_data.active_code = res.data.active_code;
            _this.submit_data.origin_appid = res.data.origin_appid;
            _this.submit_data.name = res.data.name;
            _this.submit_data.appid = res.data.appid;
            _this.submit_data.remarks = res.data.remarks;
            _this.submit_data.type = res.data.type;
            _this.submit_data.link = res.data.link;
            _this.submit_data.inside_link = res.data.inside_link;

            _this.submit_data.cover_img_hash = res.data.cover_img.hash;


            _this.img_url.cover_img_imageUrl = res.data.cover_img.url;
            console.log( _this.img_url.cover_img_imageUrl);

            this.srcList[0] = this.img_url.cover_img_imageUrl;


          }).catch(res => {

          })




      },
    },
    data() {
      return {

        show: false,

        // 图片上传地址
        img_upload_url: '',

        insideLinkList:[],


        srcList: [],

        //上传图片
        img_url: {
          cover_img_imageUrl: '',
          logo_img_imageUrl: '',
          list_img_imageUrl: ''
        },

        //压缩质量
        imgQuality: 1,



        // 上传图片的请求头
        img_headers: {

          'token': '',
          'hash-key': '',
          'platform': 'pc',
          'app-version': 'admin',
          'port': 'admin',
          'city-tag':localStorage.getItem('city_tag')

        },



        // 表单数据
        submit_data: {
          origin_appid: '',
          appid: '',
          cover_img_hash: '',
          type: '',
          link: '',
          name: '',
          remarks: '',
          inside_link:''
        },



        submit_rules: {
          name: {
            placeholder: '请输入广告名称',
            rules: {
              required: true,
              message: '广告名称需在5-50字之内',
              regulation: 'between',
              rulesData: [5, 51]
            }
          },
          cover_img_hash: {
            placeholder: '',
            rules: {
              required: true,
              message: '封面图片哈希值错误',
              regulation: 'lt_str',
              rulesData: 'json_array'
            }
          }
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {

      typeChange(){

        if(_this.submit_data.type == '0'){

          _this.submit_data.origin_appid = '';
          _this.submit_data.appid = '';
        }

      },
      // 判断图片的img_url是否存在
      imgUrlDeg() {
        if (_this.img_url.cover_img_imageUrl !== '') {
          return true;
        } else {
          _this.$message.error("未上传图片信息")
          return false;
        }
      },

      // 身份证人像面上传成功后执行
      coverImgSuccess(res, file) {

        // 将返回的哈希值存到对应的数组中
        // _this.cover_img_arrway.push(res.data.img_hash);

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.cover_img_hash = res.data.img_hash;

        // 设置img标签显示的图片路径
        _this.img_url.cover_img_imageUrl = URL.createObjectURL(file.raw);

        _this.srcList[0] = this.img_url.cover_img_imageUrl;

      },



      // 图片压缩方法
      dataURItoBlob(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
          type: type
        });
      },


      // 图片上传之前执行的函数
      beforeAvatarUpload(file) {

        // 添加请求头
        _this.img_headers.token = localStorage.getItem(config.localStorage_token_name);
        _this.img_headers['hash-key'] = _this.$hash_key();


        return new Promise(resolve => {
          const reader = new FileReader();
          const image = new Image();
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const width = image.width * _this.imgQuality;
            const height = image.height * _this.imgQuality;
            canvas.width = width;
            canvas.height = height;
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL(file.type);
            const blobData = _this.dataURItoBlob(dataUrl, file.type);
            resolve(blobData)
          }
          reader.onload = (e => {
            image.src = e.target.result;
          });
          reader.readAsDataURL(file);
        })
      },



      // 关闭方法
      closeDialog() {
        _this.show = false;

        _this.submit_data ={
          origin_appid: '',
          appid: '',
          cover_img_hash: '',
          type: '',
          link: '',
          name: '',
          remarks: '',
          inside_link:''
        };

      },


      // 提交
      onSubmit() {

        _this.$post(
            "/advert/editActiveSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
            this.$message.success(res.msg);


          }).catch(res => {

          })
      },





    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .verify_remarks {
    font-size: 14px;
    color: #606266;
  }

  .quill-editor {
    width: 80%;
  }
  .text-red{
    color: red;
    font-size: 14px;
  }
</style>
